import { Button } from '@otter-ai/den-components';
import type { UploadButtonProps } from '@rpldy/upload-button';
import { asUploadButton } from '@rpldy/upload-button';

const UploadButton = asUploadButton(({ onClick }: UploadButtonProps) => {
  return (
    <Button size="lg" className="text-md" onClick={onClick}>
      Browse files
    </Button>
  );
});

function DisabledUploadButton() {
  return (
    <Button size="lg" className="text-md" disabled={true}>
      Browse files
    </Button>
  );
}

export { UploadButton, DisabledUploadButton };
